import { defineMessages } from 'react-intl';

import type { PasFind } from '../../../components/FindPasEditDialog';

export type PasStage =
  | 'unprocessed'
  | 'drafted'
  | 'withPhoto'
  | 'submitted'
  | 'published';

export const PAS_STAGES: PasStage[] = [
  'unprocessed',
  'drafted',
  'withPhoto',
  'submitted',
  'published',
];

/** Path below the site's PAS page; the first stage is the index route. */
export const PAS_STAGE_PATHS: Record<PasStage, string> = {
  unprocessed: '',
  drafted: 'drafted',
  withPhoto: 'photos',
  submitted: 'submitted',
  published: 'published',
};

export const pasStageMessages = defineMessages({
  unprocessed: { id: 'sitePas.tab.unprocessed', defaultMessage: 'Unprocessed' },
  drafted: { id: 'sitePas.tab.drafted', defaultMessage: 'Drafted' },
  withPhoto: { id: 'sitePas.tab.withPhoto', defaultMessage: 'With photo' },
  submitted: { id: 'sitePas.tab.submitted', defaultMessage: 'Submitted' },
  published: { id: 'sitePas.tab.published', defaultMessage: 'Published' },
});

/**
 * `amcrStatus` is set only for records Acolyte created. Other AMCR-IDs count
 * as published once their public record is cached, otherwise as submitted,
 * because PAS does not expose records before they are archived.
 */
export const getPasStage = ({
  amcrId,
  amcrStatus,
  amcrData,
}: PasFind): PasStage => {
  if (!amcrId?.trim()) {
    return 'unprocessed';
  }

  if (amcrStatus === 'registered') {
    return amcrData?.files?.length ? 'withPhoto' : 'drafted';
  }

  if (amcrStatus === 'submitted') {
    return 'submitted';
  }

  if (amcrStatus === 'archived' || amcrData) {
    return 'published';
  }

  return 'submitted';
};
